// Shared by Gatsby's build, metadata and navigation so their URLs stay in sync.
const LANGUAGES = ["en", "pl"]

function normalizePath(pathname = "/") {
  const path = pathname.split(/[?#]/)[0].replace(/\/+$/, "") || "/"
  return path === "/" || /\.[^/]+$/.test(path) ? path : `${path}/`
}

function getLocaleFromPath(pathname = "/") {
  return /^\/pl(?:\/|$)/.test(normalizePath(pathname)) ? "pl" : "en"
}

function getBasePath(pathname = "/") {
  return normalizePath(
    normalizePath(pathname).replace(/^\/(en|pl)(?=\/|$)/, "")
  )
}

function isBlogPath(pathname) {
  return getBasePath(pathname).startsWith("/blog/")
}

function getLocalizedPath(pathname, locale) {
  const language = LANGUAGES.includes(locale) ? locale : "en"
  const suffix = pathname.match(/[?#].*$/)?.[0] || ""
  const basePath = getBasePath(pathname)
  return `/${language}${basePath}${suffix}`
}

function getCanonicalPath(pathname) {
  // The blog's main content is English in every UI language.
  return isBlogPath(pathname)
    ? getBasePath(pathname)
    : getLocalizedPath(normalizePath(pathname), getLocaleFromPath(pathname))
}

function getLanguageAlternates(pathname) {
  if (isBlogPath(pathname)) return []
  return [
    ...LANGUAGES.map(lang => ({
      lang,
      path: getLocalizedPath(normalizePath(pathname), lang),
    })),
    {
      lang: "x-default",
      path: getLocalizedPath(normalizePath(pathname), "en"),
    },
  ]
}

module.exports = {
  LANGUAGES,
  normalizePath,
  getLocaleFromPath,
  getBasePath,
  isBlogPath,
  getLocalizedPath,
  getCanonicalPath,
  getLanguageAlternates,
}
